import styled from 'styled-components';

export const DotElement = styled.span`
	background-color: rgba(var(--new-qd--font-color), 1);
	border-radius: 50%;
	display: inline-block;
	height: 5px;
	min-width: 5px;
`;

export const DotsContainer = styled.div`
	display: flex;
	gap: 5px;
`;

export const NewQDMethodsCollapseListElementContainer = styled.li`
	align-items: center;
	border-bottom: 1px solid var(--new-qd--list-border-color);
	display: flex;
	gap: 10px;
	justify-content: flex-start;
	padding: 8px 0;
	width: 100%;

	svg {
		color: rgba(var(--qd-modal-contrast-text), 1);
	}
`;

export const Text = styled.span`
	color: rgba(var(--new-qd--font-color), 1);
`;
